import Cookies from 'js-cookie';

function unsetSegmentIdentity() {
  // Unset Identity
  const { host } = window.location;
  localStorage.removeItem('ajs_user_id');
  localStorage.removeItem('ajs_user_traits');
  Cookies.remove('ajs_user_id', { path: '/', domain: '.kumu.live' });
  Cookies.remove('ajs_user_traits', { path: '/', domain: '.kumu.live' });
  Cookies.remove('ajs_user_id', { path: '/', domain: host });
  Cookies.remove('ajs_user_traits', { path: '/', domain: host });
}

export default unsetSegmentIdentity;
